import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './home.component';
import { FooterLoaderComponent } from '../footer/footer-loader.component';
import { HeaderLoaderComponent } from '../header/header-loader.component';
//import { HomeAuthResolver } from './home-auth-resolver.service';
import { SharedModule } from '../../shared.module';

const homeRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: '',
    component: HomeComponent,
    resolve: {
  //    isAuthenticated: HomeAuthResolver
    }
  }
]);

@NgModule({
  imports: [
    homeRouting,
    SharedModule
  ],
  declarations: [
    HomeComponent,
    FooterLoaderComponent,
    HeaderLoaderComponent 
  ],
  providers: [
    //HomeAuthResolver
  ]
})
export class HomeModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/home/home.module.ts